
/**
 * ./src/landing/Landing.js
 * 
 * This component serves as the landing page of the app, which is the 
 * biggest file in landing folder. It displays the user's progress, including 
 * reading speed, focus time, and comprehension improvement. Users are welcomed 
 * back and provided with a "Start Exercise 1" button to continue their training.
 */


import React from 'react';
import './Landing.css';
import Header from './Header';
import MainBody from './MainBody';
import { useNavigate, useLocation } from 'react-router-dom';  // Import useNavigate and useLocation

const Landing = () => {
  const navigate = useNavigate();  // Initialize the navigation hook
  const location = useLocation();
  const username = location.state?.username || 'User';

  // Create a function to handle button click to navigate to the dashboard
  const handleStartClick = () => {
    navigate('/dashboard');  // Redirect to the dashboard page
  };

  return (
    <div className="landing">
      <Header />
      <MainBody handleStartClick={handleStartClick} />  {/* Pass the click handler to MainBody */}
    </div>
  );
};

export default Landing;
